const [firebasePromise, resolveFirebase] = Promise.external();
export default firebasePromise;
export {resolveFirebase};
